export const GET_OTP_SETTINGS = 'GET_OTP_SETTINGS/get_otp_settings'
export const DISPATCHED_OTP_DATA = 'DISPATCHED_OTP_DATA/dispatch_otp_form_data'
export const SHOW_OTP_SETTINGS = 'SHOW_OTP_SETTINGS/show_otp_settings'
export const UPDATE_OTP_SETTINGS = 'UPDATE_OTP_SETTINGS/update_otp_settings'

export const OTP_OPTIONS = [
  { label: 'Active', value: '1' },
  { label: 'Inactive', value: '0' },
];

